module.exports = __webpack_public_path__ + "static/media/usersnap-logo.a9fe9f9d.png";